import styled, {
    css,
} from 'styled-components';

import {
    Text,
} from '@zillow/constellation';

export const StyledDiv = styled.div`
    display: flex;
    align-items: center;
`;

export const StyledText = styled(Text)`
    color: #737279;
    font-weight: 600;

    ${props => props.on && css`
        /* replaces color when enabled*/
        color: #189C88;
    `}
`;
